import { useQuery } from '@tanstack/react-query';
import { Link, useParams, useRouteContext } from '@tanstack/react-router';

const PLATFORM_LABEL = { android: 'Android', ios: 'iOS', web: 'Web' } as const;

/** App instances of the environment; each opens its settings page (BB-13). */
export function AppsPage() {
  const { environmentId } = useParams({ from: '/env/$environmentId/settings/apps' });
  const { api } = useRouteContext({ from: '/env/$environmentId/settings/apps' });
  const { data, isPending, isError } = useQuery({
    queryKey: ['apps', environmentId],
    queryFn: () => api.listApps(environmentId),
  });

  if (isPending) return <p aria-busy="true">Loading apps…</p>;
  if (isError) return <p role="alert">Apps could not be loaded.</p>;
  if (data.length === 0) return <p className="empty-state">No apps registered in this environment.</p>;

  return (
    <section>
      <h1>Apps</h1>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Platform</th>
            <th scope="col">Identifier</th>
            <th scope="col">API ID</th>
          </tr>
        </thead>
        <tbody>
          {data.map((app) => (
            <tr key={app.id}>
              <td>
                <Link to="/env/$environmentId/settings/apps/$appId" params={{ environmentId, appId: app.id }}>
                  {app.name}
                </Link>
              </td>
              <td>{PLATFORM_LABEL[app.platform]}</td>
              <td>
                <code>{app.identifier}</code>
              </td>
              <td>
                <code>{app.apiId}</code>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
